import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { debounceTime, map, Subscription } from 'rxjs';
import { User } from 'src/app/classes/user';
import { CalendarGroup } from 'src/app/classes/calendar';
import { CalendarService } from 'src/app/services/calendar.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
	selector: 'app-calendar-group-editor',
	templateUrl: './calendar-group-editor.component.html',
	styleUrls: [ './editor.component.css' ]
})
export class CalendarGroupEditorComponent implements OnInit, AfterViewInit, OnDestroy {


	private _group = new CalendarGroup();
	@Input() set group( val: CalendarGroup ) {
		this._group = val;
		this.updateValueForm();
	}
	get group() { return this._group; }

	formG1 = new FormGroup({});
	myInputs: { [key: string]: DataInput } = {};

	@Input() users: User[] = [];

	@Output() done = new EventEmitter<CalendarGroup>();
	@Output() deleted = new EventEmitter<CalendarGroup>();


	bInProgress = false;
	subscriptions = new Subscription();

	bIsDuplicate = false;


	constructor(
		private calendarService: CalendarService,
		private matSnackBar: MatSnackBar
	) {}


	ngOnInit() {

		const di = new DataInput();
		di.id = "name";
		di.label = "Name";
		di.type = "text";
		di.required = true;
		di.maxlength = 50;
		this.myInputs[ "name" ] = di;

		const di2 = new DataInput();
		di2.id = "enabled";
		di2.label = "Aktiviert";
		di2.type = "check";
		this.myInputs[ "enabled" ] = di2;

		const di3 = new DataInput();
		di3.id = "userSubscribable";
		di3.label = "vom Benutzer abonnierbar";
		di3.type = "check";
		this.myInputs[ "userSubscribable" ] = di3;

		const di4 = new DataInput();
		di4.id = "chatGroup";
		di4.label = "Kommunikationsgruppe";
		di4.type = "check";
		this.myInputs[ "chatGroup" ] = di4;

	}

	ngAfterViewInit() {

		setTimeout( () => {

			this.updateValueForm();

			this.subscriptions.add(
				this.formG1.valueChanges.pipe(
					debounceTime( 400 ),
					map( values => {

						if( !this.formG1.valid ) return;
						if( !this._group.vgId ) return;
						const newName = "" + this.formG1.get( "name" )?.value;
						this.bIsDuplicate = !this.calendarService.isUniqueCalendarName( this._group.vgId, newName );
						if( this.bIsDuplicate ) return;

						this.save();

					})
				).subscribe()
			);


		}, 1 );

	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}


	updateValueForm() {

		// console.log( "this.formG1.get( 'name' )", this.formG1.get( 'name' ) )
		if( this.formG1.get( 'name' ) ) {	// the formgroup is already initialized
			this.formG1.reset();
			this.formG1.patchValue( {
				name: this._group.vgName,
				enabled: this._group.vgAktiv,
				userSubscribable: !this._group.arbeitsgruppe,
				chatGroup: this._group.vgChat
			} );
		}

	}

	cancel() {
		this.done.emit( new CalendarGroup() );
	}

	reset() {
		this.updateValueForm();
	}

	save() {

		const elementToSave = { ...this._group } as CalendarGroup;

		elementToSave.vgName = this.formG1.get( "name" )?.value || "";
		elementToSave.vgAktiv = this.formG1.get( "enabled" )?.value || false;
		elementToSave.arbeitsgruppe = !(this.formG1.get( "userSubscribable" )?.value || false);
		elementToSave.vgChat = !!(this.formG1.get( "chatGroup" )?.value || false);


		this.bInProgress = true;
		this.calendarService.saveCalendarGroup( elementToSave ).subscribe( savedCG => {

			this.bInProgress = false;
			if( savedCG ) {

				this.matSnackBar.open( 'Erfolgreiche Speicherung', 'Speichern' );
				this.done.emit();

				this._group.vgAktiv = savedCG.vgAktiv;
				this._group.vgName = savedCG.vgName;
				this._group.vgId = savedCG.vgId;
				this._group.arbeitsgruppe = savedCG.arbeitsgruppe;
				this._group.vgChat = savedCG.vgChat;
				this.formG1.markAsPristine();

				this.formG1.patchValue( {
					name: this._group.vgName,
					enabled: this._group.vgAktiv,
					userSubscribable: !this._group.arbeitsgruppe,
					chatGroup: this._group.vgChat
				}, { emitEvent: false } );

			}

		});

	}

	/*
	disable() {

		this.matDialog.open(
			ConfirmationDialogComponent,
			{ data: "Möchten Sie die Veranstaltungsgruppe'" + this._group.vgName + "' wirklich löschen?" }
		)
		.afterClosed().subscribe( result => {

			if( !result ) return;

			this.calendarService.deleteCalendarGroup( this._group.vgId ).subscribe( b => {

				if( b ) this.deleted.emit();

			});

		});

	}
	*/

}
